import { List, Map as ImmutableMap } from 'immutable';
export const isList = val => {
  return List.isList(val);
};
export const isNotNull = value => value != null;
export function assertUnreachable(__x, message = 'Exhaustive check was insufficient') {
  throw new Error(message);
}

/**
 * From "How can I use Immutable maps with TypeScript?" in
 * https://product.hubteam.com/docs/frontend/docs/typescript-faqs.html
 * A type that can wrap a TypeScript interface and provide hinting for an immutable Map of the same structure
 */

// A utility function to build an immutable Map of a given structure, ensuring that initial keys and values conform to the given type
export const buildTypedMap = data => ImmutableMap(data);